import I18n from 'I18n';
import styled, { mediaQuery, css, theme } from 'academy-common-lib/utils/Styling';
import HorizontalLayoutContainer from '../HorizontalLayoutContainer';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error img
import academyLogo from 'bender-url!../../../../../images/hubspot-academy-logo-color.svg';
import UIImage from 'UIComponents/image/UIImage';
import LanguageLinks from './LanguageLinks';
import FooterNavGroup from './FooterNavGroup';
import { getPublicLang } from 'academy-common-lib/utils/url';
import { footerLinks, communityLinks, resourcesLinks, supportAndToolsLinks } from './footerLinks';
import { appendHubsContent } from '../../../../utils/urls';
import NavGroupLink from './NavGroupLink';
import SocialLinks from './SocialLinks';
import LegalLinks from './LegalLinks';
import UIList from 'UIComponents/list/UIList';
import ErrorBoundary from '../../../../components/ErrorBoundary';
import { ThemedPrimaryButtonMixin } from '../../../../components/ThemedComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledFooter = styled.footer.withConfig({
  displayName: "PublicPageFooter__StyledFooter",
  componentId: "gs32hr-0"
})(["background-color:", ";padding-top:32px;color:", ";", " a.footer-link{font-weight:500;color:", ";text-decoration:none;&:hover{color:", ";}}"], theme.colors.PANTERA, theme.colors.OLAF, mediaQuery('notTablet', css(["padding-top:96px;"])), theme.colors.BATTLESHIP, theme.colors.FLINT);
const CopyrightSection = styled.section.withConfig({
  displayName: "PublicPageFooter__CopyrightSection",
  componentId: "gs32hr-1"
})(["text-align:center;color:", ";flex-shrink:0;", ""], theme.colors.BATTLESHIP, mediaQuery('notLaptop', css(["text-align:left;"])));
const FooterBottom = styled.section.withConfig({
  displayName: "PublicPageFooter__FooterBottom",
  componentId: "gs32hr-2"
})(["border-top:1px solid ", ";padding:32px 0 48px;", " ", ""], theme.colors.EERIE, mediaQuery('notTablet', css(["display:flex;flex-wrap:wrap;flex-direction:column-reverse;align-content:center;gap:16px;padding-bottom:48px;"])), mediaQuery('notLaptop', css(["flex-wrap:nowrap;flex-direction:row-reverse;justify-content:space-between;"])));
const SupportButton = styled(UIButton).attrs({
  use: 'primary'
}).withConfig({
  displayName: "PublicPageFooter__SupportButton",
  componentId: "gs32hr-3"
})(["width:100%;a{color:", ";}", " ", ""], theme.colors.OLAF, ThemedPrimaryButtonMixin, mediaQuery('notTablet', css(["width:auto;"])));
const FooterColumnsContainer = styled.div.withConfig({
  displayName: "PublicPageFooter__FooterColumnsContainer",
  componentId: "gs32hr-4"
})(["", ""], mediaQuery('notTablet', css(["margin-bottom:72px;display:flex;flex-wrap:nowrap;justify-content:space-between;"])));
const SupportAndSocialColumn = styled.div.withConfig({
  displayName: "PublicPageFooter__SupportAndSocialColumn",
  componentId: "gs32hr-5"
})(["margin-top:32px;text-align:center;", ""], mediaQuery('notTablet', css(["margin-top:0;text-align:right;"])));
const HubSpotAcademyLogo = styled(UIImage).withConfig({
  displayName: "PublicPageFooter__HubSpotAcademyLogo",
  componentId: "gs32hr-6"
})(["max-width:200px;filter:brightness(1000%) brightness(95%);"]);
const PublicPageFooter = () => {
  const publicLang = getPublicLang();
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    children: /*#__PURE__*/_jsx(StyledFooter, {
      children: /*#__PURE__*/_jsx(HorizontalLayoutContainer, {
        children: /*#__PURE__*/_jsxs("nav", {
          children: [/*#__PURE__*/_jsxs(FooterColumnsContainer, {
            children: [/*#__PURE__*/_jsx(FooterNavGroup, {
              headingText: I18n.text('academyPublic.publicFooter.communityHeading'),
              children: /*#__PURE__*/_jsx(UIList, {
                children: communityLinks[publicLang].map(link => /*#__PURE__*/_jsx(NavGroupLink, {
                  link: link
                }, link.i18nKey))
              })
            }), /*#__PURE__*/_jsx(FooterNavGroup, {
              headingText: I18n.text('academyPublic.publicFooter.resourcesHeading'),
              children: /*#__PURE__*/_jsx(UIList, {
                children: resourcesLinks[publicLang].map(link => /*#__PURE__*/_jsx(NavGroupLink, {
                  link: link
                }, link.i18nKey))
              })
            }), /*#__PURE__*/_jsx(FooterNavGroup, {
              headingText: I18n.text('academyPublic.publicFooter.supportHeading'),
              children: /*#__PURE__*/_jsx(UIList, {
                children: supportAndToolsLinks[publicLang].map(link => /*#__PURE__*/_jsx(NavGroupLink, {
                  link: link
                }, link.i18nKey))
              })
            }), /*#__PURE__*/_jsxs(SupportAndSocialColumn, {
              children: [/*#__PURE__*/_jsx(SupportButton, {
                href: appendHubsContent(footerLinks.SUPPORT_BUTTON.hrefs[publicLang] || footerLinks.SUPPORT_BUTTON.hrefs.en, I18n.text(footerLinks.SUPPORT_BUTTON.i18nKey)),
                rel: "noopener noreferrer",
                target: "_blank",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: footerLinks.SUPPORT_BUTTON.i18nKey
                })
              }), /*#__PURE__*/_jsx(SocialLinks, {})]
            })]
          }), /*#__PURE__*/_jsx(LanguageLinks, {}), /*#__PURE__*/_jsxs(FooterBottom, {
            children: [/*#__PURE__*/_jsx(LegalLinks, {}), /*#__PURE__*/_jsxs(CopyrightSection, {
              children: [/*#__PURE__*/_jsx(HubSpotAcademyLogo, {
                alt: I18n.text('academyPublic.publicFooter.hubSpotAcademyLogoAlt'),
                responsive: false,
                src: academyLogo,
                width: 200
              }), /*#__PURE__*/_jsx("p", {
                children: /*#__PURE__*/_jsx("small", {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "academyPublic.publicFooter.copyRight",
                    options: {
                      year: new Date().getFullYear().toString()
                    }
                  })
                })
              })]
            })]
          })]
        })
      })
    })
  });
};
export default PublicPageFooter;